/* eslint-disable @typescript-eslint/no-unused-vars,no-underscore-dangle */
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { createRef } from 'lit/directives/ref.js';
import { portal } from 'lit-modal-portal';

import { SkipPayBaseElement } from './base';
import csTranslations from './translations/cs';
import huTranslations from './translations/hu';
import skTranslations from './translations/sk';
import type { TranslationKey } from './translations/types';
import { Currency, Language, Product } from './types';

import './banner';
import './modal';

@customElement('skip-pay-placement')
export class SkipPayPlacement extends SkipPayBaseElement {
	dialogRef = createRef<HTMLDialogElement>();

	@property({ type: String })
	product: Product = 'PAY_IN_THREE';

	@property({ type: String, attribute: 'merchant-name' })
	merchantName = window.location.hostname;

	@property({ type: Number })
	amount?: number;

	@property({ type: String })
	currency?: Currency = 'CZK';

	@property({ type: String })
	language: Language = 'cs';

	@property({ type: Boolean, attribute: 'with-landing-link' })
	withLandingLink = false;

	@property({ type: Number })
	textVariant = 1;

	private _getTranslation(): Record<TranslationKey, string> {
		const lang = this.language;
		switch (lang) {
			case 'sk':
				return skTranslations;
			case 'hu':
				return huTranslations;
			default:
				return csTranslations;
		}
	}

	private _portalTemplate() {
		const translations = this._getTranslation();

		return html`
			<sp-modal
				.dialogRef=${this.dialogRef}
				.product=${this.product}
				.translations=${translations}
				.withLandingLink=${this.withLandingLink}
				.language=${this.language}
				.merchantName=${this.merchantName}
				.amount=${this.amount}
				.currency=${this.currency}
			></sp-modal>
		`;
	}

	override render() {
		const translations = this._getTranslation();
		return this.checkBannerVisibility(this.product, this.amount, this.currency)
			? html`
					<sp-banner
						product=${this.product}
						.translations=${translations}
						.textVariant=${this.textVariant}
						.merchantName=${this.merchantName}
						.amount=${this.amount}
						.currency=${this.currency}
						.language=${this.language}
						@click=${() => this.dialogRef.value?.showModal()}
						aria-labelledby="skippay-banner-title"
					></sp-banner>
					${portal(this._portalTemplate(), document.body)}
				`
			: null;
	}
}

declare global {
	interface HTMLElementTagNameMap {
		'skip-pay-placement': SkipPayPlacement;
	}
}
